import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { useDrag } from "@use-gesture/react"
import { defineBlock, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Logo",
  icon: "star-filled",
  description: "A single logo",
}

export default defineBlock("content/logo-item", (props) => {
  if (!props.logo && env.admin) {
    return (
      <div className="logo-item flex items-center justify-center relative w-full aspect-[4/3]">
        <AdminMessage>Choose Logo</AdminMessage>
      </div>
    )
  } else if (!props.logo) {
    return null
  }

  const [scale, setScale] = useInlineEditableValue("scale", 1)
  const bindDrag: any =
    env.admin &&
    useDrag(
      (e) => {
        const d = e.offset[0]
        setScale(Math.min(2, Math.max(0.4, d / 100)))
      },
      {
        from: () => [scale * 100, 0],
        preventDefault: true,
      },
    )

  let content = (
    <ResponsiveImage
      {...props.logo}
      altText={props.title}
      caption={props.title}
      className="size-full"
      objectFit="contain"
      objectPosition="center"
    />
  )

  if (props.url && !env.admin) {
    content = (
      <a href={props.url} target="_blank" className="flex items-center justify-center w-full h-full">
        {content}
      </a>
    )
  }

  return (
    <div className="logo-item w-full aspect-[4/3] flex flex-none items-center relative isolate">
      {env.admin && (
        <div
          className="absolute top-0 left-0 size-[20px] overflow-hidden z-[1] cursor-nwse-resize touch-none"
          {...bindDrag()}
        >
          <div className="absolute top-0 left-0 size-[20px] -translate-x-1/2 -translate-y-1/2 rotate-45 bg-bg-mid" />
        </div>
      )}
      <div
        className="absolute w-full h-full z-0 inset-0 flex items-center justify-center transform-gpu scale-[--scale]"
        style={{ "--scale": scale } as any}
      >
        {content}
      </div>
    </div>
  )
})
